import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Publication } from '@widgets/shared/Publication/index.tsx';
import type { PublicationType } from '@widgets/shared/Publication/types.ts';
import { useProgramQuery } from '@src/api/api-hooks/programs/useProgramQuery.ts';
import { useUpdateProgramPublicationMutation } from '@src/api/api-hooks/programs/useUpdateProgramPublicationMutation.ts';

export const ProgramPublicationPage = () => {
  const { id } = useParams();
  const programId = Number(id);
  const { data, isLoading, isFetching, isError, isSuccess } = useProgramQuery({ id });
  const { mutateAsync: updateProgramPublicationStatus } = useUpdateProgramPublicationMutation();

  const onUpdatePublication = useCallback(
    async (
      publicationData: Partial<PublicationType>
    ): Promise<{ data?: PublicationType; error?: FetchBaseQueryError | SerializedError }> => {
      return await updateProgramPublicationStatus({ id: programId, publicationData });
    },
    [updateProgramPublicationStatus, programId]
  );

  return (
    <Publication
      entityName={'Программа'}
      onUpdatePublication={onUpdatePublication}
      publicationData={data?.publication}
      title={'Публикация видеопрограммы'}
      status={{ isSuccess, isError, isFetching, isLoading }}
    />
  );
};
